import React from "react";
import Section from "../Contact/Section";
import ContactContent from "../Contact/ContactContent";

const Contact = () => {
  document.title = "Contact | Jobcy - Job Listing Template | Themesdesign";
  return (
    <React.Fragment>
      
      <ContactContent />
    </React.Fragment>
  );
};

export default Contact;
